import { createChannel, createClient } from 'nice-grpc-web';
import { LOCAL_ENDPOINT } from '@/api/common';
import { api, notification } from '@zentrains/api';

const localChannel = createChannel(LOCAL_ENDPOINT);
export const localApi: api.v3.ZenTrainsClient = createClient(api.v3.ZenTrainsDefinition, localChannel);
export const localNotificationApi: notification.v3.NotificationClient = createClient(
  notification.v3.NotificationDefinition,
  localChannel,
);
